import moment from "moment";

export const dateYearOrPresent = (date?: string | null): number | string => date ? moment(date).year() : "present";